import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { delay, finalize, of, switchMap } from 'rxjs';
import { User } from 'src/app/features/user/user';
import { ModalConfig } from 'src/app/shared/components/modal/modal-config';
import { ROLES } from 'src/app/util/constantes';
import { USER_MESSAGES } from 'src/app/util/constantes-mensajes';
import { HelperFunctions } from 'src/app/util/util-functions';
import { v4 as uuidv4 } from 'uuid';
import { UserService } from '../user.service';
import { AuthService } from 'src/app/auth/auth.service';
@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.scss']
})
export class ManageUserComponent implements OnInit {
  // Property to get the selected user
  @Input() user: User;
  // User information form
  userForm: FormGroup;
  // Variable to set modal information
  public modalConfig: ModalConfig;
  // Property to change the modal title
  actionTitle: string = "Crear usuario";
  // Property to change the action button string
  actionButton: string = "Crear";
  // Variable to show/hide spinner
  isLoading: boolean = false;
  // Maps every possible user roles
  roles = ROLES;

  constructor(private userService: UserService, private ngbActiveModal: NgbActiveModal, private authService: AuthService) { }


  ngOnInit(): void {
    this.initForm();
    this.modalConfig = {
      modalTitle: this.actionTitle,
      ...this.modalConfig,
    };
  }

  /**
  * A function that inits the parameterForm group
  * @returns None
  */
  initForm(): void {
    if (this.user != null) {
      this.actionTitle = "Editar usuario";
      this.actionButton = "Guardar";
    }
    this.userForm = new FormGroup({
      uuid: new FormControl(this.user?.uuid || uuidv4()),
      nombre: new FormControl(this.user?.nombre, [Validators.required, Validators.maxLength(255)]),
      apellido: new FormControl(this.user?.apellido, [Validators.required, Validators.maxLength(255)]),
      email: new FormControl(this.user?.email, [Validators.required, Validators.email, Validators.maxLength(255)]),
      rol: new FormControl(this.user?.rol, [Validators.required])
    });
  }

  /**
  * A function that checks if the control is invalid
  * @returns {boolean}
  */
  hasErrors(name: string): boolean {
    const control = this.userForm.get(name) as FormControl;
    return HelperFunctions.controlIsInvalid(control);
  }

  /**
  * A function that submit the parameter object
  * @returns None
  */
  onSubmit() {
    if (this.userForm.valid) {
      const user = this.setUserData();
      this.createUpdateUser(user);
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  /**
  * Gets the user information from form fields
  * @returns {User}
  */
  setUserData(): User {
    const newUser: User = {
      ...this.userForm.getRawValue()
    };
    return newUser;
  }

  /**
   * This function creates or updates an user
   * @param {User} user
   */
  createUpdateUser(user: User) {
    this.isLoading = true;
    const subscription = this.user ? this.userService.updateUser(user) : this.userService.createUser(user);
    subscription.pipe(
      delay(500),
      switchMap((response) => this.user?.email !== user.email ? this.authService.sendEmailResetPassword(user.email) : of(response)),
      finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          this.ngbActiveModal.close({ message: USER_MESSAGES.CREATE.USER, confirmTitle: "Aceptar" });
        },
        error: (error) => {
          this.ngbActiveModal.close({ message: error.error.message, confirmTitle: "Cerrar", isError: true });
        }
      });
  }

}